export default "__VITE_ASSET__6a91074b__"